import { cn } from "@/lib/utils";

interface LogoProps {
  width?: number;
  className?: string;
}

/**
 * Prospect wordmark + concentric-square mark. SVG copied from the
 * marketing site at `prospect-website/index.html` so the two surfaces
 * stay visually identical. Update both together.
 */
export function Logo({ width = 180, className }: LogoProps) {
  const height = (width / 320) * 72;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 320 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("inline-block", className)}
      aria-label="Prospect"
    >
      <rect x="8" y="8" width="56" height="56" stroke="#c8a96e" strokeWidth="1.5" fill="none" opacity="1" />
      <rect x="16" y="16" width="40" height="40" stroke="#c8a96e" strokeWidth="1.2" fill="none" opacity="0.6" />
      <rect x="24" y="24" width="24" height="24" stroke="#c8a96e" strokeWidth="1" fill="none" opacity="0.35" />
      <rect x="31" y="31" width="10" height="10" stroke="#c8a96e" strokeWidth="0.8" fill="none" opacity="0.18" />
      <line x1="31" y1="8" x2="41" y2="8" stroke="#0a0a0c" strokeWidth="3" />
      <line x1="31" y1="16" x2="41" y2="16" stroke="#0a0a0c" strokeWidth="3" />
      <line x1="32" y1="24" x2="40" y2="24" stroke="#0a0a0c" strokeWidth="3" />
      <text
        x="84"
        y="46"
        fontFamily="Cormorant Garamond, Georgia, serif"
        fontSize="28"
        fontWeight="300"
        letterSpacing="7"
        fill="#e8e8ec"
      >
        PROSPECT
      </text>
    </svg>
  );
}
